import Enum from './Enum.js';

export default class LeadVehicleState extends Enum {
    static get entries() {
        return {
            new: 'new',
            used: 'used',
            certified: 'certified',
            demo: 'demo',
        };
    }

    static get NEW() {
        return this.entries.new;
    }

    static get USED() {
        return this.entries.used;
    }

    static get CERTIFIED() {
        return this.entries.certified;
    }

    static get DEMO() {
        return this.entries.demo;
    }

    static get translationGroup() {
        return 'leadVehicleStates';
    }

    static exist(property) {
        return this.hasOwnProperty(property);
    }
}
